import { Col, Row, Skeleton } from 'antd';
import React from 'react';
import EmployeesTeam from '@/components/Dashboard/Mock/HomeEmployeesTeam';
import WorkOrderOpen from '../DashboardEstimatorView/WorkOrderOpen';
import WorkOrderAuthorized from '../DashboardEstimatorView/WorkOrderAuthorized';
import WorkOrderClosed from '../DashboardEstimatorView/WorkOrderClosed';
import WorkOrderCanceled from '../DashboardEstimatorView/WorkOrderCanceled';
import { DashboardType } from '@/core/domain/workorder/Dashboard/Dashboard.types';
import HomeInformatives from '../Mock/HomeInformatives';
import { useDashboardData } from '@/core/domain/workorder/Dashboard/Dashboard.hooks';

const DashboardDefaultView: React.FC = () => {
  const { data, isLoading } = useDashboardData({
    dashboardType: DashboardType.default,
  });

  return (
    <Skeleton loading={isLoading} active paragraph={{ rows: 10 }}>
      <Row gutter={[16, 16]}>
        <Col span={24} sm={12} md={12} lg={12} xl={6}>
          <WorkOrderOpen
            workOrderValueOpenMonth={data?.workOrderOpenMonth}
            workOrderValueTotal={data?.workOrderOpenTotal}
          />
        </Col>

        <Col span={24} sm={12} md={12} lg={12} xl={6}>
          <WorkOrderAuthorized
            workOrderValueAuthorizedMonth={data?.workOrderAuthorizedMonth}
            workOrderValueTotal={data?.workOrderAuthorizedTotal}
          />
        </Col>

        <Col span={24} sm={12} md={12} lg={12} xl={6}>
          <WorkOrderCanceled
            workOrderValueCanceledMonth={data?.workOrderCancelledMonth}
            workOrderValueTotal={data?.workOrderCancelledTotal}
          />
        </Col>

        <Col span={24} sm={12} md={12} lg={12} xl={6}>
          <WorkOrderClosed
            workOrderValueClosedMonth={data?.workOrderClosedMonth}
            workOrderValueTotal={data?.workOrderClosedTotal}
          />
        </Col>

        <Col span={24} lg={12}>
          <EmployeesTeam />
        </Col>

        <Col span={24} lg={12}>
          <HomeInformatives />
        </Col>
      </Row>
    </Skeleton>
  );
};

export default DashboardDefaultView;
